<template>
  <div>
    <p>
      <strong
        >Case
        <span v-if="caseCommentsList[0]">{{ caseCommentsList[0].refers }}</span>
        Comments</strong
      >
      <v-icon
        color="rgba(21, 102, 124, 0.9)"
        @click="$emit('close')"
        style="float: right"
        >mdi-close</v-icon
      >
    </p>
    <div v-if="caseCommentsList[0]">
      <div v-for="(comment, index) in caseCommentsList" :key="index">
        <v-divider></v-divider>
        <p><b>Date Created:</b> {{ comment.dateCreated }}</p>
        <p>{{ comment.text }}</p>
      </div>
    </div>
    <div v-else>None</div>
  </div>
</template>

<script>

export default {
  name: "commentsPopup",
  props: {
    record: Object,
    caseCommentsList: Array
  },
  data: () => ({
  }),
  methods: {}
};
</script>

<style scoped>
align-center {
  text-align: center;
}
align-left {
  text-align: left;
}
align-right {
  text-align: right;
}
</style>
